const steps = [
  {
    num: '01',
    title: 'She Dials In',
    body: (
      <>
        Jessica joins your Zoom calls on your behalf. She introduces herself as your
        representative. Everyone in the room knows exactly why she&apos;s there —{' '}
        <em className="text-[#d43742] not-italic">no confusion, no awkwardness.</em>
      </>
    ),
  },
  {
    num: '02',
    title: 'She Keeps You Informed',
    body: (
      <>
        Live summaries hit your phone as the meeting unfolds. Key decisions, action items, and
        anything that{' '}
        <em className="text-[#d43742] not-italic">needs your attention</em> surfaces immediately
        — not after the fact.
      </>
    ),
  },
  {
    num: '03',
    title: 'She Brings You In',
    body: (
      <>
        When your approval is needed, Jessica sends it directly to you as a simple yes/no
        request. When your voice is needed, she{' '}
        <em className="text-[#d43742] not-italic">dials you into the meeting</em> — you never
        have to join cold.
      </>
    ),
  },
];

export default function HowItWorksSection() {
  return (
    <section
      className="py-[110px] px-[60px] border-t border-[#1e1a18] bg-[#060606] max-md:px-6"
      style={{ fontFamily: "'Work Sans', sans-serif" }}
    >
      <div className="max-w-[1080px] mx-auto">
        <span className="block text-[11px] font-bold tracking-[0.22em] text-[#d43742] uppercase mb-7">
          How It Works
        </span>
        <h2
          className="font-black text-[#faf9f7] leading-[0.95] tracking-[-0.01em]"
          style={{
            fontFamily: "'Big Shoulders Display', sans-serif",
            fontSize: 'clamp(42px, 6vw, 80px)',
          }}
        >
          Your delegate.
          <br />
          In both rooms.
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-[1px] bg-[#2a2422] mt-16">
          {steps.map((step) => (
            <div key={step.num} className="bg-[#0d0d0d] py-[44px] px-[36px]">
              <div
                className="font-black text-[#2a2422] text-[72px] leading-[1] mb-5"
                style={{ fontFamily: "'Big Shoulders Display', sans-serif" }}
              >
                {step.num}
              </div>
              <div className="text-[15px] font-bold text-[#faf9f7] tracking-[0.04em] mb-[14px] uppercase">
                {step.title}
              </div>
              <div className="text-[14px] font-light text-[#e0dbd5] leading-[1.7]">
                {step.body}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
